import apiService from '../../services/api';
import axios from 'axios/index';
import API_CONFIG from '../../api-config';

// Init state
const state = {
    items: []
};

// Actions
const actions = {
    getList: (context, params) => {
        return apiService.get('point.index', params);
    },
    create: (context, params) => {
        return apiService.post('point.index', params);
    },
    update: (context, params) => {
        return apiService.put('point.detail', params);
    },
    delete: (context, params) => {
        return apiService.delete('point.detail', params);
    },
    exportExcel: (context, params) => {
        return axios.get(API_CONFIG.BASE_URL + API_CONFIG.point.export, {
            responseType: 'blob',
            params
        });
    },
    importExcel: (context, params) => {
        return axios
            .post(API_CONFIG.BASE_URL + API_CONFIG.point.import, params.formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
                params: {
                    pointGroupId: params.pointGroupId
                }
            })
            .then(response => response.data);
    }
};

// Mutation
const mutations = {};

export default {
    namespaced: true,
    state,
    actions,
    mutations
};
